import React, { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";
import { getLoggedInUser, loginWithFacebookToken } from "./library/user";
import { useFacebook } from "./container/User/facebook";
import Home from "./container/Home/Home";

import InfoContext from "./context";
import ContextHome from "./container/Home/ContextHome";
import ContextStore from "./container/Store/ContextStore";
import ContextPersonalArea from "./container/PersonalArea/ContextPersonalArea";
import ContextCreative from "./container/Creative/ContextCreative";
import Panoramas from "./container/Panorama/Panoramas";
import VillagePanorama from "./container/Panorama/VillagePanorama";
import CarbonFootprintInquiry from "./components/CarbonFootprintInquiry/CarbonFootprintInquiry";
import Village from "./container/Village/Village";

// export const AppContext = React.createContext({});

const Test = () => {
  return <div>TESTE</div>;
};

const Loading = () => null;

const Store = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Store" */ "./container/Store/Store"),
  loading: Loading,
});

const ReservationList = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ReservationList" */ "./container/PersonalArea/PersonalArea"
    ),
  loading: Loading,
});

// const Payment = Loadable({
//   loader: () =>
//     import(/* webpackChunkName: "Payment" */ "./container/Payment/Payment"),
//   loading: Loading,
// });

// const Components = Loadable({
//   loader: () =>
//     import(
//       /* webpackChunkName: "Components" */ "./container/Components/Components"
//     ),
//   loading: Loading,
// });

const routes = [
  {
    path: ["/", "/en", "/fr", "/de", "/es", "/it"],
    component: ContextHome,
    // component: Home,
    exact: true,
  },
  {
    // for test deployment in aldeiashistoricasdeportugal.com
    path: ["/plat"],
    component: ContextHome,
    // component: Home,
    exact: true,
  },
  {
    path: [
      "/local/:slug",
      "/en/local/:slug",
      "/fr/local/:slug",
      "/de/local/:slug",
      "/es/local/:slug",
      "/it/local/:slug",
    ],
    component: ContextStore,
    exact: true,
  },
  {
    path: [
      "/evento/:slug",
      "/en/evento/:slug",
      "/fr/evento/:slug",
      "/de/evento/:slug",
      "/es/evento/:slug",
      "/it/evento/:slug",
    ],
    component: ContextStore,
    exact: true,
  },
  {
    path: [
      "/reservas",
      "/en/reservas",
      "/fr/reservas",
      "/de/reservas",
      "/es/reservas",
      "/it/reservas",
    ],
    component: ContextPersonalArea,
    exact: true,
  },
  {
    path: [
      "/confirm-email/:id",
      "/en/confirm-email/:id",
      "/fr/confirm-email/:id",
      "/de/confirm-email/:id",
      "/es/confirm-email/:id",
      "/it/confirm-email/:id",
    ],
    component: ContextHome,
    exact: true,
  },
  {
    path: [
      "/reset-pwd/:rpid",
      "/en/reset-pwd/:rpid",
      "/fr/reset-pwd/:rpid",
      "/de/reset-pwd/:rpid",
      "/es/reset-pwd/:rpid",
      "/it/reset-pwd/:rpid",
    ],
    component: ContextHome,
    exact: true,
  },
  {
    path: [
      "/industrias-criativas",
      "/en/industrias-criativas",
      "/fr/industrias-criativas",
      "/de/industrias-criativas",
      "/es/industrias-criativas",
      "/it/industrias-criativas",
    ],
    component: ContextCreative,
    exact: true,
  },
  {
    path: [
      "/panoramas",
      "/en/panoramas",
      "/fr/panoramas",
      "/de/panoramas",
      "/es/panoramas",
      "/it/panoramas",
    ],
    component: Panoramas,
    exact: true,
  },
  {
    path: [
      "/aldeia",
      "/en/aldeia",
      "/fr/aldeia",
      "/de/aldeia",
      "/es/aldeia",
      "/it/aldeia",
    ],
    component: Village,
    exact: false,
  },
  {
    path: [
      "/carbon",
      "/en/carbon",
      "/fr/carbon",
      "/de/carbon",
      "/es/carbon",
      "/it/carbon",
    ],
    component: CarbonFootprintInquiry,
    exact: false,
  },
  {
    path: [
      "/platform",
      "/en/platform",
      "/fr/platform",
      "/de/platform",
      "/es/platform",
      "/it/platform",
    ],
    component: ContextHome,
    exact: false,
  },
  // {
  //   path: "/lodge/:lodge",
  //   component: Lodge,
  //   exact: true,
  // },
  // {
  //   path: "/restaurant/:restaurant",
  //   component: Restaurant,
  //   exact: true,
  // },
  // {
  //   path: "/experience/:experience",
  //   component: Experience,
  //   exact: true,
  // },
  // {
  //   path: "/pagamentos",
  //   component: Payment,
  //   exact: true,
  // },
  // {
  //   path: "/teste",
  //   component: Test,
  //   exact: true,
  // },
  // {
  //   path: "/components",
  //   component: Components,
  //   exact: true,
  // },
];

const Routes = () => {
  return (
    <>
      {/* <AppContext.Provider value={value}> */}
      {/* <InfoContext> */}
      <Switch>
        {routes.map(({ path, exact, component }, index) => (
          <Route key={index} path={path} exact={exact} component={component} />
        ))}
      </Switch>
      {/* </InfoContext> */}
      {/* </AppContext.Provider> */}
    </>
  );
};

export default Routes;
